import { memo, SVGProps } from 'react'

export const AnyPairsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M9 13.5l1.5 1.5L9 16.5 7.5 15 9 13.5z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.062 8.062A7.001 7.001 0 0122 9c0 3.548-2.64 6.48-6.062 6.938A7.001 7.001 0 012 15c0-3.548 2.64-6.48 6.062-6.938zM15 4a5 5 0 01.917 9.916 7.005 7.005 0 00-5.833-5.833A5.002 5.002 0 0115 4zm-6 6a5 5 0 110 10 5 5 0 010-10z"
    />
  </svg>
)

export const GuaranteedPriceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M13 13V7h-2v6h2zM13 17v-2h-2v2h2z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.591 4.045l-1.68-2.911-2.912 1.68-2.912-1.68-1.68 2.911H4.043v3.363l-2.911 1.68L2.813 12l-1.68 2.911 2.91 1.681v3.362h3.363l1.681 2.912L12 21.185l2.911 1.68 1.681-2.91h3.362v-3.362l2.912-1.682L21.184 12l1.68-2.912-2.911-1.681V4.045H16.59zm-8.03 2l1.258-2.18L12 5.126l2.18-1.26 1.258 2.18h2.516v2.517l2.18 1.258L18.875 12l1.258 2.18-2.18 1.258v2.516h-2.516l-1.259 2.18-2.18-1.259-2.179 1.259-1.258-2.18H6.044v-2.517l-2.18-1.258L5.125 12 3.863 9.82l2.18-1.258V6.045H8.56z"
    />
  </svg>
)

export const CircleCrossIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-7.233 0l3.006 3.005-1.768 1.768L12 13.767l-3.005 3.005-1.768-1.768 3.005-3.005-3.005-3.005 1.768-1.767L12 10.23l3.005-3.005 1.768 1.767L13.767 12z"
      fill="currentColor"
    />
  </svg>
))

export const ZeroFeeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12a8 8 0 10-16 0 8 8 0 0016 0zM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M7.293 15.293l8-8 1.414 1.414-8 8-1.414-1.414z" />
    <path d="M7.293 8.707l1.414 1.414 1.414-1.414-1.414-1.414-1.414 1.414zM16.707 15.293l-1.414-1.414-1.414 1.414 1.414 1.414 1.414-1.414z" />
  </svg>
)

export const CircleMinusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path fill="currentColor" d="M4 11h16v2H4z" />
  </svg>
)

export const CirclePlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M4 11h16v2H4v-2z" fill="currentColor" />
    <path d="M13 4v16h-2V4h2z" fill="currentColor" />
  </svg>
)

export const SwapIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M7 2l5.5 5.49-1.42 1.41L8 5.81V21H6V5.81L2.92 8.9 1.51 7.49 7 2zM17 22l-5.5-5.5 1.42-1.41L16 18.18V3h2v15.18l3.09-3.09 1.41 1.41L17 22z" />
  </svg>
))

export const SearchIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.7421 15.0369C12.2197 15.0369 15.0389 12.2178 15.0389 8.74015C15.0389 5.26253 12.2197 2.44336 8.7421 2.44336C5.26448 2.44336 2.44531 5.26253 2.44531 8.74015C2.44531 12.2178 5.26448 15.0369 8.7421 15.0369Z"
      stroke="#737C88"
      strokeWidth="2.14286"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5584 17.5545L13.9062 13.9023"
      stroke="#737C88"
      strokeWidth="2.14286"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
))
